"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderText = exports.BottomSheetCloseButton = exports.BottomSheetHeaderContainer = exports.BottomSheetBackground = exports.Content = exports.Overlay = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const themed_text_1 = require("../themed-text");
exports.Overlay = styled_components_1.default.div `
  transition: all 0.2s;
  z-index: 1008;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  background-color: #232f3d;
  opacity: ${({ isOpen }) => (isOpen ? '.60' : '0')};
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
`;
exports.Content = styled_components_1.default.div `
  display: flex;
  width: 100vw;
  z-index: 1009;
  position: fixed;
  top: auto;
  left: 0;
  bottom: 0;
  transform: translateY(${({ isOpen, height }) => (isOpen ? '0px' : `${height}px`)});
  transition: transform 0.5s ease;
  align-items: end;
  overflow: hidden;
`;
exports.BottomSheetBackground = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacings.large} ${theme.spacings.mediumPlus}`};
  width: 100%;
  background: ${monera_app_core_1.Gray_1600};
  border-radius: 16px 16px 0 0;
`;
exports.BottomSheetHeaderContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacings.medium};
`;
exports.BottomSheetCloseButton = styled_components_1.default.button `
  position: fixed;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  right: 10px;
  background-color: transparent;
  &:focus {
    border: 3px solid #c8f3fa;
  }
`;
exports.HeaderText = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  padding-right: 60px;
`;
